import { connect } from 'react-redux';
import { BillingAction, ExchangeAction } from '../../actions';
import { bindActionCreators } from 'redux';
import Billing from './Billing';

const mapStateToProps = (state) => {
	return {
		exchange: state.exchange,
		stat: state.stat,
		user: state.user,
        paidBilling: state.invoice.paidBilling,
        pendingBilling: state.invoice.pendingBilling,
		isNewPay: state.invoice.isNewPay,
		isEditPay: state.invoice.isEdit,
		invoice_id: state.invoice.invoice_id
	};
};

const mapDispatchToProps = (dispatch) => ({
	storeBilling: bindActionCreators(BillingAction.readData, dispatch),
	// setNewPay: bindActionCreators(BillingAction.setNewInvoice, dispatch),
    storeExchange: bindActionCreators(ExchangeAction.readData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Billing);
